module.exports = __webpack_public_path__ + "img/ph.17ee28b1.png";